import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import logo from './../logo.png'

export const Navigation = (props) => {
  const location = useLocation();
  const history = useHistory();
  const isServicePage = location.pathname.startsWith('/service/');
  const [activeSection, setActiveSection] = React.useState('');

  // Detect active section based on hash or scroll position
  React.useEffect(() => {
    if (isServicePage) return;

    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        setActiveSection(hash);
      }
    };

    const handleScroll = () => {
      const sections = ['#about', '#services', '#Engagements', '#testimonials', '#Partenaires', '#Galerie', '#Devis', '#contact2'];
      const scrollPosition = window.scrollY + 150;

      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.querySelector(sections[i]);
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    // Check initial hash
    if (window.location.hash) {
      setActiveSection(window.location.hash);
    }

    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isServicePage]);

  const closeMobileMenu = () => {
    // Close mobile menu if open (Bootstrap 3)
    const navbarCollapse = document.getElementById('bs-example-navbar-collapse-1');
    const toggleButton = document.querySelector('.navbar-toggle');
    
    if (navbarCollapse) {
      // Check if menu is open (Bootstrap 3 uses 'in' class, Bootstrap 4+ uses 'show')
      const isOpen = navbarCollapse.classList.contains('in') || navbarCollapse.classList.contains('show');
      
      if (isOpen && toggleButton) {
        // Trigger click on toggle button to close menu
        toggleButton.click();
      } else if (isOpen) {
        // Fallback: manually remove classes
        navbarCollapse.classList.remove('in', 'show');
        if (toggleButton) {
          toggleButton.classList.add('collapsed');
          toggleButton.setAttribute('aria-expanded', 'false');
        }
        navbarCollapse.setAttribute('aria-expanded', 'false');
      }
    }
  };

  const handleNavClick = (e, anchor) => {
    e.preventDefault();
    
    // Close mobile menu if open
    closeMobileMenu();
    
    // Small delay to ensure menu closes before navigation
    setTimeout(() => {
      if (isServicePage) {
        // If on service page, navigate to home with anchor hash
        history.push(`/${anchor}`);
      } else {
        // If on home page, update URL hash and scroll
        window.location.hash = anchor;
        setActiveSection(anchor);
        const element = document.querySelector(anchor);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, 100);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    
    // Close mobile menu if open
    closeMobileMenu();
    
    // Small delay to ensure menu closes before navigation
    setTimeout(() => {
      if (isServicePage) {
        history.push('/');
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setActiveSection('');
      }
    }, 100);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          
          <a 
            className="navbar-brand page-scroll" 
            href="#page-top" 
            style={{marginLeft:"-150px", cursor: 'pointer'}}
            onClick={handleLogoClick}
          >
            <p className="ju">
              <img src={logo} style={{width:"200px"}} className="img-logo" alt="Logo"></img>   
              <span className="clean position-relative" style={{position:'relative',top:'4px'}}>
              </span>
            </p> 
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li className={activeSection === '#about' ? 'active' : ''}>
              <a href="#about" className="page-scroll test" onClick={(e) => handleNavClick(e, '#about')}>
              À propos              </a>
            </li>
            <li className={activeSection === '#services' ? 'active' : ''}>
              <a href="#services" className="page-scroll test" onClick={(e) => handleNavClick(e, '#services')}>
                Services
              </a>
            </li>
            <li className={activeSection === '#Engagements' ? 'active' : ''}>
              <a href="#Engagements" className="page-scroll test" onClick={(e) => handleNavClick(e, '#Engagements')}>
               Engagements
              </a>
            </li>
            <li className={activeSection === '#testimonials' ? 'active' : ''}>
              <a href="#testimonials" className="page-scroll test" onClick={(e) => handleNavClick(e, '#testimonials')}>
              Avis
              </a>
            </li>
            <li className={activeSection === '#Partenaires' ? 'active' : ''}>
              <a href="#Partenaires" className="page-scroll test" onClick={(e) => handleNavClick(e, '#Partenaires')}>
              Consultation personnalisée
              </a>
            </li>
            <li className={activeSection === '#Galerie' ? 'active' : ''}>
              <a href="#Galerie" className="page-scroll test" onClick={(e) => handleNavClick(e, '#Galerie')}>
              Galerie
              </a>
            </li>
            <li className={activeSection === '#Devis' ? 'active' : ''}>
              <a href="#Devis" className="page-scroll test" onClick={(e) => handleNavClick(e, '#Devis')}>
              Devis 
              </a>
            </li>
            <li className={activeSection === '#contact2' ? 'active' : ''}>
              <a href="#contact2" className="page-scroll test" onClick={(e) => handleNavClick(e, '#contact2')}>
              Contact 
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
